import React from 'react';
import NvIcon from 'shared/components/nv-icon';
import { askNovoAIBtnComponent } from '../styles';

interface AskNovoAiButtonProps {
  disabled?: boolean;
  onClick?: () => void;
  children?: React.ReactNode;
  isSmall?: boolean;
}

const AskNovoAIButton = ({
  onClick = () => {},
  children,
  disabled,
  isSmall,
}: AskNovoAiButtonProps) => (
  <div css={askNovoAIBtnComponent(disabled, isSmall)} className='button-wrapper'>
    <div className='gradient-border'>
      <button disabled={disabled} type='button' className='novoai-button' onClick={onClick}>
        <NvIcon icon='gen-ai' size={isSmall ? 'xss-smallest' : 'small'} className='novoai-icon' />
        {children}
      </button>
    </div>
  </div>
);

export default AskNovoAIButton;
